import { useEffect, useState, useCallback } from "react";
import { getFilesByPetId } from "../../api/uploadService";

export const usePetImageGalleryFiles = (id, trigger, initialPage = 1, initialLimit = 10, sort = 'createdAt', order = 'desc') => {
    const [items, setItems] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0, sort: sort, order: order },
        sort: null,
        search: null
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortBy, setSortBy] = useState("createdAt");
    const [orderBy, setOrderBy] = useState("desc");

    const fetchData = useCallback(
        //id, page = 1, limit = 10, tags="", mode="", sort="", order=""
        async (id, page = initialPage, limit = initialLimit, tags = "profilePicture", append = false, sort = sortBy, order = orderBy, search = searchTerm) => {
        setLoading(true);
        try {
            // id, page = 1, limit = 10, tags="", mode="", sort="", order=""
            const response = await getFilesByPetId(id, page, limit, tags, "", sort, order );
            setItems(prev => {
            if (append) {
                return {
                ...response,
                data: [...(prev.data || []), ...response.data],
                };
            }
            // 🔑 Reset pagination when not appending (fresh search or initial load)
            return {
                ...response,
                pagination: { ...response.pagination, page }, 
            };
            });
            return response;
        } catch (err) {
            console.error("Failed to fetch images:", err);
        } finally {
            setLoading(false);
        }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchData(id, initialPage, initialLimit, "profilePicture", false, sortBy, orderBy, searchTerm);
    }, [trigger, fetchData, initialPage, initialLimit, searchTerm]);

    // page = initialPage, limit = initialLimit, tags = "", append = false, sort = sortBy, order = orderBy, search = searchTerm
    const loadMore = async () => {
        const nextPage = items.pagination.page + 1;
        if (nextPage <= items.pagination.totalPages) {
          //id, page = 1, limit = 10, tags="", mode="", sort="", order=""
          await fetchData(id, nextPage, items.pagination.limit, "profilePicture", true, sortBy, orderBy, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, items.pagination.limit, "profilePicture", false, sortBy, orderBy, searchTerm);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(id, initialPage, initialLimit, "profilePicture", false, sortBy, orderBy, searchTerm);
    };

    // page = initialPage, limit = initialLimit, tags = "", append = false, sort = sortBy, order = orderBy, search = searchTerm
    const reorderList = async (page, sort, order) => {
        setSortBy(sort);
        setOrderBy(order);
        // Reset results and pagination when searching
        await fetchData(page, items.pagination.limit, "", false, sort, order, searchTerm);
    };

    const updateItem = (updatedAttachment) => {
      setItems((prev) => ({
        ...prev,
        data: prev.data.map((att) =>
          att.id === updatedAttachment.id ? updatedAttachment : att
        ),
      }));
    };

    const removeItem = (attachmentId) => {
      setItems((prev) => {
        const newData = prev.data.filter((att) => att.id !== attachmentId);

        return {
          ...prev,
          data: newData,
          pagination: {
            ...prev.pagination,
            total: Math.max(prev.pagination.total - 1, 0),
          },
        };
      });
    };

    return { items, loading, loadMore, searchFunction, resetParent, reorderList, updateItem, removeItem };
};